import { createContext } from 'react';
import { ImportStrategy } from 'components/imports/types';

interface IImportStrategyContext {
    importStrategy: ImportStrategy;
}

const ImportStrategyContext = createContext<IImportStrategyContext>({
    importStrategy: {} as ImportStrategy,
});

export type { IImportStrategyContext };
export { ImportStrategyContext };
